// Internal flag-bag type — the contract between App.ts and buildFilteredItems.
// No longer a public attribute payload. The public API is one boolean HTML
// attribute per capability (`showlms`) — see App.ts.
//
// CAPABILITY_FLAG_NAMES is the single runtime source of truth for which
// reactive properties carry capability flags. App.ts iterates this list to
// (a) detect a change in any flag and (b) build the bag passed to
// buildFilteredItems — adding a flag here + a matching `@property` in App.ts
// is enough to wire dispatch end-to-end (no hard-coded `changed.has("…")` or
// bag-literal edits in App.ts to forget).
export const CAPABILITY_FLAG_NAMES = ["showLms"] as const;
export type CapabilityFlagName = (typeof CAPABILITY_FLAG_NAMES)[number];
export type CapabilityFlags = Partial<Record<CapabilityFlagName, boolean>>;
